import * as api from "@/api/williams/project";
import { Project } from "@/api/project";
import { queryKeys } from "../../queryKeys";
import { useMutation, useQueryClient } from "react-query";

export function useDeleteProject() {
  const queryClient = useQueryClient();

  return useMutation(async (project: Project) => {
    await api.deleteProject(project.id);

    queryClient.removeQueries(queryKeys.project.single(project.id));

    queryClient.invalidateQueries(queryKeys.project.list());
    queryClient.invalidateQueries(queryKeys.scopeOfWork.list());
    queryClient.invalidateQueries(queryKeys.testEvent.list());
  });
}
